export const VALID_IMAGE_TYPES = ["image/png", "image/jpeg"];
export const DEFAULT_MAX_IMAGE_SIZE = 5 * 1048576; // 5MB

export const isValidImageType = (file: File): boolean =>
  VALID_IMAGE_TYPES.includes(file.type);

export const isValidImageSize = (file: File, maxSize = DEFAULT_MAX_IMAGE_SIZE): boolean =>
  file.size <= maxSize;

export const validateImage = (
  file: File,
  maxSize = DEFAULT_MAX_IMAGE_SIZE
): { valid: boolean; error: string } => {
  if (!isValidImageType(file)) {
    return { valid: false, error: "Invalid image type. Only PNG and JPG are allowed." };
  }
  if (!isValidImageSize(file, maxSize)) {
    const sizeMB = maxSize / 1048576;
    const sizeLabel = sizeMB >= 1 ? `${sizeMB} MB` : `${maxSize / 1024} KB`;
    return { valid: false, error: `File size must be less than ${sizeLabel}.` };
  }
  return { valid: true, error: "" };
};

export const getImagePreviewUrl = (image: any): Promise<string> => {
  if (!image) return Promise.resolve("");
  if (typeof image === "string") return Promise.resolve(image);
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.readAsDataURL(image);
  });
};
